import {
  DiagnosticMethod,
  DiagnosticStatus,
  IDiagnostic,
} from "apps/project-iq/models/IDiagnostic";

export const VIOLET_SOFT_BG = "rgba(107, 106, 217, 0.086)";
export const AMBER_SOFT_BG = "rgba(217, 138, 43, 0.086)";
export const AMBER_INK = "rgb(168, 95, 16)";
export const GREEN_SOFT_BG = "rgba(47, 158, 110, 0.086)";
export const GREEN_LINE = "rgba(47, 158, 110, 0.25)";
export const GREEN_INK = "rgb(30, 138, 81)";

export const deriveDiagnosticStatus = (
  diagnostic: IDiagnostic,
): DiagnosticStatus => {
  if (diagnostic.status) return diagnostic.status;
  if (diagnostic.distributions.length === 0) return "draft";
  if (diagnostic.distributions.some((d) => !d.isClosed)) return "in_progress";
  return "completed";
};

export const METHOD_LABELS: Record<DiagnosticMethod, string> = {
  ai_interview: "AI Interview",
  survey: "Survey",
  in_person_interviews: "In-Person Interviews",
  workshops_focus_groups: "Workshops & Focus Groups",
};

export const ALL_DIAGNOSTIC_METHODS = Object.keys(
  METHOD_LABELS,
) as DiagnosticMethod[];

export const STATUS_LABELS: Record<DiagnosticStatus, string> = {
  in_progress: "In Progress",
  completed: "Completed",
  draft: "Draft",
};
